<template>
  <div class="d-flex flex-row">
    <div
        class="flex-row-auto offcanvas-mobile w-300px w-xl-350px"
        id="kt_profile_aside"
    >
      <div class="card card-custom card-stretch">
        <div class="card-body pt-4">
          <div class="d-flex align-items-center">
            <div
                class="symbol symbol-60 symbol-xxl-100 mr-5 align-self-start align-self-xxl-center"
            >
              <div
                  class="symbol-label"
                  :style="{
                  backgroundImage: `url(${photo})`
                }"
              ></div>
              <i class="symbol-badge bg-success"></i>
            </div>
            <div>
              <a
                  class="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary"
              >{{name + " " + surname}}</a
              >
              <div class="text-muted">#{{member_id}}</div>
            </div>
          </div>
          <!--end::User-->
          <!--begin::Contact-->
          <div class="py-9">
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">{{$t('general.email')}}:</span>
              <a class="text-muted text-hover-primary">{{ email }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">{{$t('general.phone')}}:</span>
              <span class="text-muted">{{ phone }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">{{$t('user_detail.ref_no')}}:</span>
              <span class="text-muted">{{ ref_no }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">{{$t('user_detail.point_count')}}:</span>
              <span class="text-muted">{{ point_count }}</span>
            </div>
            <div class="d-flex align-items-center justify-content-between mb-2">
              <span class="font-weight-bold mr-2">Kupa Sayısı:</span>
              <span class="text-muted">20</span>
            </div>
          </div>
          <!--end::Contact-->
          <!--begin::Nav-->
          <div
              class="navi navi-bold navi-hover navi-active navi-link-rounded"
              role="tablist"
          >
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4 active"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="0"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/General/User.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.user_information') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="1"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Design/Layers.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.sub_user_information') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="2"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Code/Thunder-circle.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.point') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="3"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                        src="media/svg/icons/Code/Time-schedule.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.change_history') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="4"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                        src="media/svg/icons/Communication/Add-user.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.invite') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="5"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg
                        src="media/svg/icons/Code/Info-circle.svg"
                    />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.contact_us') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="6"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Communication/Chat6.svg" />
                  </span>
                </span>
                <span class="navi-text font-size-lg">{{ $t('user_detail.reading_message') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="7"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/General/Lock.svg" />
                  </span>
                </span>
                <span class="navi-text">{{ $t('user_detail.login_status') }}</span>
              </a>
            </div>
            <div class="navi-item mb-2">
              <a
                  class="navi-link py-4"
                  @click="setActiveTab"
                  style="cursor:pointer"
                  data-tab="8"
                  data-toggle="tab"
                  role="tab"
                  aria-selected="false"
              >
                <span class="navi-icon mr-2">
                  <span class="svg-icon">
                    <inline-svg src="media/svg/icons/Files/User-folder.svg" />
                  </span>
                </span>
                <span class="navi-text">{{ $t('user_detail.profile_history') }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--begin::Content-->
    <div class="flex-row-fluid ml-lg-8">
      <b-tabs class="hide-tabs" v-model="tabIndex">
        <b-tab active>
          <UserInformation></UserInformation>
        </b-tab>
        <b-tab>
          <SubUsers></SubUsers>
        </b-tab>
        <b-tab>
          <Points></Points>
        </b-tab>
        <b-tab>
          <ChangeHistory></ChangeHistory>
        </b-tab>
        <b-tab>
          <Invitation></Invitation>
        </b-tab>
        <b-tab>
          <ContactUs></ContactUs>
        </b-tab>
        <b-tab>
          <ReadingMessage></ReadingMessage>
        </b-tab>
        <b-tab>
          <LoginLogs></LoginLogs>
        </b-tab>
        <b-tab>
          <ProfileHistory></ProfileHistory>
        </b-tab>
      </b-tabs>
    </div>
    <!--end::Content-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import UserInformation from "@/view/pages/users/layouts/UserInformation";
import SubUsers from "@/view/pages/users/layouts/SubUsers";
import Points from "@/view/pages/users/layouts/Points";
import ChangeHistory from "@/view/pages/users/layouts/ChangeHistory";
import Invitation from "@/view/pages/users/layouts/Invitation";
import ContactUs from "@/view/pages/users/layouts/ContactUs";
import ReadingMessage from "@/view/pages/users/layouts/ReadingMessage";
import LoginLogs from "@/view/pages/users/layouts/LoginLogs";
import ProfileHistory from "@/view/pages/users/layouts/ProfileHistory";
import KTDropdown2 from "@/view/content/dropdown/Dropdown2";

export default {
  name: "UserManagement",
  components: {
    UserInformation,
    SubUsers,
    Points,
    ChangeHistory,
    Invitation,
    ContactUs,
    ReadingMessage,
    LoginLogs,
    ProfileHistory,
    KTDropdown2,
  },
  data() {
    return {
      tabIndex: 0,
      name : 'Emre',
      surname : 'Yıldız',
      phone : '0555 555 55 55',
      email : localStorage.getItem('email'),
      photo : 'media/users/300_21.jpg',
      ref_no : '73786514',
      member_id : 3871304,
      point_count : '7.510.00'
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: this.name +" "+ this.surname }]);
  },
  methods: {
    /**
     * Set current active on click
     * @param event
     */
    setActiveTab(event) {
      let target = event.target;
      if (!event.target.classList.contains("navi-link")) {
        target = event.target.closest(".navi-link");
      }

      const tab = target.closest('[role="tablist"]');
      const links = tab.querySelectorAll(".navi-link");
      // remove active tab links
      for (let i = 0; i < links.length; i++) {
        links[i].classList.remove("active");
      }

      // set clicked tab index to bootstrap tab
      this.tabIndex = parseInt(target.getAttribute("data-tab"));

      // set current active tab
      target.classList.add("active");
    }
  }
};
</script>
